// @flow
import React from 'react';
import NavigateLink from 'app/common/react/ui/NavigateLink';
import type { BasicImage } from 'app/packages/pinterest-flow-types/image';
import type { Videos } from 'app/packages/pinterest-flow-types/video';
import VideoIndicatorIcon from 'app/common/react/components/video/VideoIndicatorIcon';
import { VideoFormatEnum } from 'app/common/react/components/ScheduledPin/types';
import { Box, Card, Image, Text } from 'gestalt';

type Props = {|
  pin: {
    id: string,
    images: {
      '170x'?: BasicImage,
      '136x136'?: BasicImage,
      '236x': BasicImage,
      '474x': BasicImage,
      '60x60'?: BasicImage,
      '736x': BasicImage,
      orig: BasicImage,
    },
    title?: string,
    videos: ?{ id: string, video_list: Videos },
    video_status?: number,
    video_status_message?: {
      closeup: string,
      title: string,
      subtitle: string,
    },
  },
|};

const Styles = {
  overlay: {
    __style: {
      backgroundColor: '#000',
      opacity: 0.4,
    },
  },
};

export default function StatusPinRep(props: Props) {
  const {
    pin: { id: pinId, images, title: pinTitle, videos, video_status_message },
  } = props;
  // cannot destructure with fallback value since video_status_message can be null (vs undefined)
  const videoStatusMessage = video_status_message || {};
  const image = images && images['236x'];
  const video = videos && videos.video_list[VideoFormatEnum.V_HLSV4];

  const { duration } = video || {};

  return (
    <React.Fragment>
      <Card>
        <NavigateLink to={`/pin/${pinId}`}>
          <Box overflow="hidden" position="relative" shape="rounded">
            {image && (
              <Image
                alt={pinTitle || ''}
                color="lightGray"
                naturalHeight={image.height}
                naturalWidth={image.width}
                src={image.url}
              />
            )}
            {!!duration && (
              <Box padding={2} position="absolute" bottom left display="flex">
                <VideoIndicatorIcon duration={duration} />
              </Box>
            )}
            <Box
              position="absolute"
              top
              bottom
              left
              right
              dangerouslySetInlineStyle={Styles.overlay}
            />
            <Box position="absolute" top left padding={5} width="100%">
              <Text color="white" overflow="normal" size="xl" weight="bold">
                {videoStatusMessage.title}
              </Text>
              <Box marginTop={4}>
                <Text color="white" size="sm" overflow="normal">
                  {videoStatusMessage.subtitle}
                </Text>
              </Box>
            </Box>
          </Box>
          <Box
            display="flex"
            alignItems="start"
            justifyContent="between"
            marginTop={1}
            paddingX={1}
          >
            <Box flex="grow">
              {pinTitle && (
                <Box paddingY={1}>
                  <Text inline size="sm" weight="bold">
                    {pinTitle}
                  </Text>
                </Box>
              )}
            </Box>
          </Box>
        </NavigateLink>
      </Card>
    </React.Fragment>
  );
}
